export default [
    {
        id: 1,
        name_ca: 'Curt termini',
        name_es: 'Corto plazo',
        name_en: 'Short term'
    }, {
        id: 2,
        name_ca: 'Mig termini',
        name_es: 'Medio plazo',
        name_en: 'Medium term'
    }, {
        id: 3,
        name_ca: 'Llarg termini',
        name_es: 'Largo plazo',
        name_en: 'Long term'
    }
]



// WEBPACK FOOTER //
// ./src/options/terms.js